(function () {
  'use strict';

  if (window.__NEW_LOGO_CART_REFRESH_GUARD__) return;
  window.__NEW_LOGO_CART_REFRESH_GUARD__ = true;

  const QTY_INTERACTION_WINDOW_MS = 1800;
  let lastQtyInteractionAt = 0;
  const LINE_UPDATE_DEBOUNCE_MS = 220;
  const lineUpdateTimers = new Map();
  const lineUpdatePayloads = new Map();

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function isDrawerOpen() {
    const drawer = getDrawer();
    return Boolean(drawer && drawer.hasAttribute('open'));
  }

  function markQtyInteraction() {
    lastQtyInteractionAt = Date.now();
  }

  function shouldBypassGuard(detail) {
    if (!detail || typeof detail !== 'object') return false;
    if (detail.force === true) return true;
    if (detail.open === true) return true;
    if (String(detail.source || '') === 'new-logo-explicit') return true;
    return false;
  }

  function isRecentQtyInteraction() {
    return Date.now() - lastQtyInteractionAt <= QTY_INTERACTION_WINDOW_MS;
  }

  function bindQtyInteractionTracking() {
    const selector =
      'cart-drawer .quantity__button, cart-drawer .quantity__input, cart-drawer input[name="updates[]"]';

    document.addEventListener(
      'click',
      (event) => {
        if (event.target && event.target.closest(selector)) {
          markQtyInteraction();
        }
      },
      true
    );

    document.addEventListener(
      'change',
      (event) => {
        if (event.target && event.target.closest(selector)) {
          markQtyInteraction();
        }
      },
      true
    );
  }

  function bindCartRefreshGuard() {
    document.addEventListener(
      'cart:refresh',
      (event) => {
        if (!isDrawerOpen()) return;
        if (shouldBypassGuard(event?.detail)) return;
        if (!isRecentQtyInteraction()) return;

        event.stopImmediatePropagation();
        if (typeof event.preventDefault === 'function') {
          event.preventDefault();
        }

        document.dispatchEvent(
          new CustomEvent('new-logo:cart-refresh-suppressed', {
            detail: {
              reason: 'recent-quantity-interaction',
              at: Date.now(),
            },
          })
        );
      },
      true
    );
  }

  function patchCartItemsQuantityUpdates() {
    const cartItemsClass = window.customElements.get('cart-items');
    if (!cartItemsClass || !cartItemsClass.prototype) return;
    const proto = cartItemsClass.prototype;
    if (proto.__newLogoDebouncedQuantityPatchApplied) return;

    const originalUpdateQuantity = proto.updateQuantity;
    if (typeof originalUpdateQuantity !== 'function') return;

    proto.updateQuantity = function patchedUpdateQuantity(line, quantity, name, target) {
      const normalizedLine = String(line || '').trim();
      const normalizedQuantity = Number.parseInt(String(quantity || '0'), 10);

      if (!normalizedLine) {
        return originalUpdateQuantity.call(this, line, quantity, name, target);
      }

      // Keep removals immediate for reliable delete behavior.
      if (!Number.isFinite(normalizedQuantity) || normalizedQuantity <= 0) {
        const existingTimer = lineUpdateTimers.get(normalizedLine);
        if (existingTimer) {
          clearTimeout(existingTimer);
          lineUpdateTimers.delete(normalizedLine);
        }
        lineUpdatePayloads.delete(normalizedLine);
        return originalUpdateQuantity.call(this, line, quantity, name, target);
      }

      const existingTimer = lineUpdateTimers.get(normalizedLine);
      if (existingTimer) {
        clearTimeout(existingTimer);
      }

      lineUpdatePayloads.set(normalizedLine, {
        line,
        quantity,
        name,
        target,
      });

      const timer = setTimeout(() => {
        lineUpdateTimers.delete(normalizedLine);
        const latest = lineUpdatePayloads.get(normalizedLine);
        lineUpdatePayloads.delete(normalizedLine);
        if (!latest) return;
        originalUpdateQuantity.call(this, latest.line, latest.quantity, latest.name, latest.target);
      }, LINE_UPDATE_DEBOUNCE_MS);

      lineUpdateTimers.set(normalizedLine, timer);
    };

    proto.__newLogoDebouncedQuantityPatchApplied = true;
  }

  function init() {
    bindQtyInteractionTracking();
    bindCartRefreshGuard();
    patchCartItemsQuantityUpdates();
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements
        .whenDefined('cart-items')
        .then(() => {
          patchCartItemsQuantityUpdates();
        })
        .catch(() => {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
